import React from 'react'
import { translations } from '../lang/texts';

export const LanguageContext = React.createContext(translations["en"]);
export const SetLanguageContext = React.createContext<any>(null);  // TODO: typing

